import React, { useEffect, useState } from 'react'
import { Show, useShowContext, SimpleShowLayout, TabbedShowLayout, Tab, useTranslate } from 'react-admin'
import { Container, Grid, Typography, CircularProgress, Box, Button } from '@mui/material'
import { CardCommon } from 'src/components/uiElements'
import { ShowListElement } from 'src/components/uiElements/CRUD/ShowListElement'
import { HistoryTable } from './logic/HistoryTable'
import { AirTab } from './logic/product/AirTab'
import { AssistanceTab } from './logic/product/Assistance'
import { FlexiTab } from './logic/product/FlexiTab'
import { BaggageTab } from './logic/product/BaggageTab'
import HepstarTab from './logic/product/HepstarTab'
import { ServicePackageTab } from './logic/product/ServicePackageTab'

const ShowContent = (props) => {
  const { isLoading, record } = useShowContext()
  const translate = useTranslate()
  const [productAir, setProductAir] = useState({})
  const [productAssistance, setProductAssistance] = useState({})
  const [productFlexi, setProductFlexi] = useState(null)
  const [productBaggage, setProductBaggage] = useState(null)
  const [productHepstar, setProductHepstar] = useState(null)
  const [productServicePackage, setProductServicePackage] = useState(null)

  const existProduct = (record, product_name) => {
    if (record && record?.data?.length !== 0) {
      return record?.data?.find((item) => item.ref_table_detail === product_name)
    }
    return null
  }

  useEffect(() => {
    if (record) {
      setProductAir(existProduct(record, 'air_detail'))
      setProductAssistance(existProduct(record, 'assistance_detail'))
      const hepCandidate = record?.data?.find((d) => d?.form_ancillaries_hepstar)
      setProductHepstar(hepCandidate || null)
      if (record.flexible_rate_data && record.flexible_rate_data.is_selected) {
        setProductFlexi(record.flexible_rate_data)
      } else {
        setProductFlexi(null)
      }
      if (record.service_package_data && record.service_package_data.is_selected) {
        setProductServicePackage({
          ...record.service_package_data,
          currency: record.data?.[0]?.prebooking?.currency || 'ARS'
        })
      } else {
        setProductServicePackage(null)
      }
      if (record.ancillary_baggage_amount && record.ancillary_baggage_amount > 0) {
        setProductBaggage({
          amount: record.ancillary_baggage_amount,
          currency: record.data?.[0]?.prebooking?.currency || 'ARS'
        })
      } else {
        setProductBaggage(null)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [record])


  const isLoadingProduct = (product) => {
    if (product) {
      if (product[0]?.isOther) {
        return !Boolean(product[0].product)
      } else {
        if (Array.isArray(product) && product?.length > 0) {
          return Object.keys(product[0])?.length <= 1
        }
      }
    }

    return false
  }

  const LoadingProduct = ({ product_name }) => {
    return (
      <Box display={'flex'} alignItems={'center'}>
        <CircularProgress sx={{ marginRight: '5px' }} size={'10px'} />
        {translate(`ra.title.${product_name}`)}
      </Box>
    )
  }

  const loadingHistory = (record) => {
    if (record && 'history_status' in record) {
      return false
    }
    return true
  }

  const goToReservation = () => {
    window.open(`/#/reservation/${record?.reservation_id}/show`, '_blank')
  };

  return (
    <Container className='content'>
      <CardCommon title={translate('ra.entity.operation')} actions={null}>
        <SimpleShowLayout>
          <Grid container spacing={3}>
            <ShowListElement
              label={translate('ra.field.id')}
              value={record?.external_id}
              loading={isLoading}
            />
            <ShowListElement
              label={translate('ra.field.work_unit')}
              value={record?.work_unit?.long_name}
              loading={isLoading}
            />
            <ShowListElement
              label={translate('ra.field.hash')}
              value={record?.hash}
              loading={isLoading}
            />
          </Grid>
          {record?.reservation_id && (<Button onClick={goToReservation} variant='contained' style={{ height: '20%' }}>
            {translate('ra.action.view_reservation')}
          </Button>)}
          <Typography variant='h6' style={{ marginTop: '20px' }}>
            {translate('ra.title.history')}
          </Typography>
          <HistoryTable history={record?.history_status} loading={loadingHistory(record) || isLoading} />
        </SimpleShowLayout>
        <TabbedShowLayout>
          {productAir ? (
            <Tab
              value='1'
              label={
                isLoadingProduct(productAir) ? (
                  <LoadingProduct product_name='aerial' />
                ) : (
                  `${translate('ra.title.aerial')}`
                )
              }
              disabled={isLoadingProduct(productAir)}
            >
              <AirTab product={productAir} loading={isLoading} />
            </Tab>
          ) : undefined}
          {productAssistance?.length > 0 ? (
            <Tab
              value='1'
              label={
                isLoadingProduct(productAssistance) ? (
                  <LoadingProduct product_name='assistance' />
                ) : (
                  `${translate('ra.title.assistance')} (${productAssistance?.length})`
                )
              }
              disabled={isLoadingProduct(productAssistance)}
            >
              <AssistanceTab product={productAssistance} loading={isLoading} />
            </Tab>
          ) : undefined}
          {productFlexi && (
            <Tab value='flexi' label={`${translate('ra.title.flexi')}`}>
              <FlexiTab product={productFlexi} loading={isLoading} />
            </Tab>
          )}
          {productBaggage && (
            <Tab value='baggage' label={`${translate('ra.title.extra_baggage')}`}>
              <BaggageTab product={productBaggage} loading={isLoading} />
            </Tab>
          )}
          {productHepstar && (
            <Tab value='hepstar' label={`Hepstar`}>
              <HepstarTab product={productHepstar} loading={isLoading} />
            </Tab>
          )}
          {productServicePackage && (
            <Tab value='servicePackage' label='Paquete Premium'>
              <ServicePackageTab product={productServicePackage} loading={isLoading} />
            </Tab>
          )}
        </TabbedShowLayout>
      </CardCommon>
    </Container>
  )
}
const ShowWrapper = ({ children }) => <Container maxWidth='false'> {children}</Container>


export const OperationShow = (props) => {
  return (
    <Show component={ShowWrapper} {...props} className='CrudShowContainer' actions={null}>
      <ShowContent {...props} />
    </Show>
  )
}
